import React, { useCallback } from 'react'
import { Grid, Separator, H1, Subheading, useStatusOverlay, Skeleton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Row from '@fs/zion-ui/dist/cjs/row'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useHistory } from '@fs/zion-router'
import { useShowTemple } from '@fs/zion-permissions'
import UploadGedcomButton from '../details/researcher-trees/UploadGedcomButton'
import CreateGroupButton from './CreateGroupButton'

/**
 *
 * @param {{
 * isResearcherGroupList?: boolean
 * totalGroupCount: number | undefined
 * refetchGroupList: () => Promise<void> }} props
 * @returns {JSX.Element}
 */

export default function GroupListHeader({ isResearcherGroupList, totalGroupCount, refetchGroupList }) {
  const [t] = useTranslation()
  const { isOn: familyGroupsIsOn } = useGroupsContext()
  const [showTemple, templeStatus] = useShowTemple()
  const history = useHistory()
  const showStatusOverlay = useStatusOverlay()
  const onCreateGroup = useCallback(
    (newGroupId) => {
      showStatusOverlay({ message: t('group-management.recent-group-created.description'), type: 'success' })
      refetchGroupList()
        .then((data) => {
          const newGroup = data?.memberSummaries?.find((group) => group.id === newGroupId)
          if (newGroup?.types?.includes('PRIVATE_PERSON_SHARING')) {
            return window.location.assign(`/tree/pedigree/sibling/?treeId=${newGroup.treeIds?.[0]}`)
          }
          return history.push(`/family/${newGroupId}/details`)
        })
        .catch(console.error)
    },
    [history, refetchGroupList, showStatusOverlay, t]
  )
  const headingTranslation = t(
    isResearcherGroupList ? 'group-management.research-trees.heading' : 'group-management.family-groups.heading'
  )

  let subheading
  if (isResearcherGroupList) {
    subheading = t('group-management.upload-for-tree.description')
  } else if (showTemple) {
    subheading = t(
      familyGroupsIsOn
        ? 'group-management.create-for-chat-ordinances-and-tree.description'
        : 'group-management.create-for-chat-and-ordinances.description'
    )
  } else {
    subheading = t(
      familyGroupsIsOn
        ? 'group-management.create-for-chat-and-tree.description'
        : 'group-management.create-for-chat.description'
    )
  }
  return (
    <Grid gutters="none">
      <H1 size="H3">
        {headingTranslation}
        {['loaded', 'error'].includes(templeStatus) ? (
          <Subheading>{subheading}</Subheading>
        ) : (
          <Skeleton.Paragraph lineCount={1} />
        )}
      </H1>
      <Separator size="sm" />
      <Row gutters="none">
        {isResearcherGroupList ? (
          // eslint-disable-next-line test-selectors/button -- this has a data-testid in the component
          <UploadGedcomButton groupsCount={totalGroupCount} onUploadGedcom={refetchGroupList} />
        ) : (
          // eslint-disable-next-line test-selectors/button -- this has a data-testid in the component
          <CreateGroupButton groupsCount={totalGroupCount} onCreateGroup={onCreateGroup} />
        )}
      </Row>
    </Grid>
  )
}
